import React, { useEffect, useState } from 'react';

import LoadingAnimation from 'components/loading-animation';
import {
  IGenerateFirstpayVaultedLinkMutation,
  useGenerateFirstpayVaultedLinkMutation,
} from 'generated/rbi-graphql';
import logger from 'utils/logger';

export interface IFirstpayHostedPageVaulted {
  // TO-DO: Interface to vaulted
  onResult: (outcome: any) => void;
}

export const FirstpayHostedPageVaulted: React.FC<IFirstpayHostedPageVaulted> = ({ onResult }) => {
  const [vaultedLink, setVaultedLink] = useState('');
  const [iframeLoaded, setIframeLoaded] = useState(false);

  const handleFirstpayLinkCompleted = (result: IGenerateFirstpayVaultedLinkMutation) => {
    setVaultedLink(result.generateFirstpayVaultedLink.link);
  };

  const [generateFirstpayVaultedLink] = useGenerateFirstpayVaultedLinkMutation({
    onCompleted: handleFirstpayLinkCompleted,
    onError: error => {
      logger.error({
        message: 'Firstpay: vaulted CC integration threw an error',
        error,
      });

      throw error;
    },
  });

  useEffect(() => {
    generateFirstpayVaultedLink();
  }, [generateFirstpayVaultedLink]);

  useEffect(() => {
    if (!vaultedLink) {
      return undefined;
    }

    function listener(event: MessageEvent) {
      const origin = new URL(event.origin);
      if (!origin.hostname.endsWith('.rbictg.com')) {
        return;
      }
      if (event.data.type !== 'vaulted-outcome') {
        return;
      }

      const body = event.data.body;

      onResult(body);
    }

    window.addEventListener('message', listener);
    return () => window.removeEventListener('message', listener);
  }, [vaultedLink, onResult]);

  return (
    <div data-testid="vaulted-card" style={{ height: '750px' }}>
      {!vaultedLink && !iframeLoaded && <LoadingAnimation fillColor={Styles.color.primary} />}
      {vaultedLink && (
        <iframe
          onLoad={() => setIframeLoaded(true)}
          data-testid="hosted-payment-form"
          title="Payment Form"
          style={{
            width: '100%',
            height: '100%',
            border: 'none',
            visibility: iframeLoaded ? 'visible' : 'hidden',
          }}
          src={vaultedLink}
        ></iframe>
      )}
    </div>
  );
};
